import canNavigateAway from '../utils/canNavigateAway';
import type { FullComposeViewState } from 'owa-calendar-compose-types';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import popoutCalendarCompose from 'owa-calendar-compose-form-store/lib/utils/popoutCalendarCompose';
import { FULL_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { orchestrator } from 'satcheljs';
import { popOutCompose, setEventBodyFromViewState } from 'owa-calendar-compose-form-actions';
import { updateCollabSpace } from '../utils/updateCollabSpace';
import { transitionModalToPopoutViewState } from '../utils/transitionModalToPopoutViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

export default orchestrator(popOutCompose, async actionMessage => {
    const store = getComposeStore();

    if (store.openedForm == FULL_COMPOSE_FORM_TYPE) {
        let viewState = store.uiState as FullComposeViewState;

        if (!(await canNavigateAway())) {
            return;
        }

        // Update the calendar event to set the collaborative space from the collaborative space store
        if (isFeatureEnabled('cal-cmp-fluidCollaborativeSpace')) {
            await updateCollabSpace(store.event, viewState.collabSpaceViewStateId);
        }

        transitionModalToPopoutViewState(viewState);
        popoutCalendarCompose(store.event, 'Compose_Header', store.originalEvent, viewState);
    } else {
        // If we try to pop out from quick compose form (For example in timepanel scenario), then just show full compose in pop out
        // Before popping out, make sure we pull out the event body
        setEventBodyFromViewState();
        popoutCalendarCompose(
            store.event,
            'TimePanelPopout',
            store.originalEvent,
            null /* viewState */,
            null /* source */,
            actionMessage.createCollabSpaceOnInitProps
        );
    }
});
